import * as React from "react";
import { default as ItemData, IPricelist } from "../data/item";

interface IPricelistProps {
    data: ItemData,
    list: IPricelist
}

interface IState {
    list: IPricelist
}

export default class PricelistView extends React.Component<IPricelistProps, IState> {
    constructor(props: IPricelistProps) {
        super(props);
        this.state = {
            list: props.list
        };
    }

    public render() {
        const l = this.state.list;
        return <form>
            <div className="item" key={l.id}>
                <div className="columns">
                    <div className="id">{l.id || "\u00A0"}</div>
                    { /* tslint:disable-next-line:jsx-no-lambda */ }
                    <div className="conversionKey"><input value={l.conversionKey} onChange={x => this.setState({ list: { ...l, conversionKey: parseInt(x.currentTarget.value, 10) } })} /></div>
                    { /* tslint:disable-next-line:jsx-no-lambda */}
                    <div className="fileName"><input value={l.fileName} onChange={x => this.setState({ list: { ...l, fileName: x.currentTarget.value } })} /></div>
                    { /* tslint:disable-next-line:jsx-no-lambda */}
                    <div className="description"><input value={l.description} onChange={x => this.setState({ list: { ...l, description: x.currentTarget.value } })} /></div>
                </div>
                <div className="commands">
                    <button title="Lagre endringer" onClick={this.save}> <i className="fa fa-floppy-o" /></button>
                    <a title="BDV" href={this.props.data.urlBdv(l.id)} type="button" className="btn"><i className="fa fa-file-o" /></a>
                    <a title="5001" href={this.props.data.url5001(l.id)} type="button" className="btn"><i className="fa fa-file-text-o" /></a>
                </div>
            </div>
        </form>;
    }

    private save = () => {
        this.props.data.putList(this.state.list);
    }
}


// WEBPACK FOOTER //
// ./src/items/pricelist.tsx